import NidApp from "./api.js";
import "flexslider";

;(function ($) {

	var $childPages = $(document.getElementById('child-pages')),
		$termList = $(document.getElementById('page-tag-list')),
		$numVisible = $(document.getElementById('num-visible')),
		$numTotal = $(document.getElementById('num-total')),
		$showMore = $(document.getElementById('show-more')),
		$pagination = $(document.getElementById('pagination')),
		storeMap = document.getElementById('store-map'),

		// Current active page term
		currentTerm = 0,

		// Number of items to show per 'page'
		showItems = 8;


	/** Reset the list to its original condition. */
	function resetChildren() {
		$('article', $childPages).addClass('hidden').slice(0, showItems).removeClass('hidden');
	}


	/**
	 * Filter the list of children by tag.
	 *
	 * @param {string} tag The tag to filter the children by.
	 */
	function filterChildren(tag) {
		$('article', $childPages).addClass('hidden');

		var visibleChildren = 0;

		$.each($('article', $childPages), function (i) {
			var $this = $(this);

			if ($this.hasClass(tag)) {
				if (visibleChildren >= showItems) {
					return false;
				}
				$this.removeClass('hidden');
				visibleChildren++;
			}

		});
	}


	function getChildrenWithTag(tag) {
		var $selector = null;

		if (0 === tag) {
			$selector = $('article', $childPages);
		} else {
			$selector = $('article.' + tag, $childPages);
		}

		return $selector;
	}


	/** Show more children */
	function loadMoreChildren() {
		var numVisible = $('article', $childPages).not('.hidden').length,
			$selector = getChildrenWithTag(currentTerm);

		$selector.slice(numVisible, numVisible + showItems).removeClass('hidden');

		$.event.trigger('pageChildrenSort');
	}


	/** Update the 'showing x of x' text. */
	function updatePostCounts() {
		var numVisible = $('article', $childPages).not('.hidden').length,
			numTotal = getChildrenWithTag(currentTerm).length;

		$numVisible.text(numVisible);
		$numTotal.text(numTotal);

		if (numVisible === numTotal) {
			$showMore.hide();
			$pagination.addClass('disabled');
		} else {
			$showMore.show();
			$pagination.removeClass('disabled');
		}
	}


	/**
	 * Lazy load for images.
	 *
	 * Checks if the actual image has been loaded if the container
	 * is visible and loads it if not.
	 */
	function maybeLoadImages() {
		$.each($('article', $childPages).not('.hidden'), function () {
			var $img = $('img', $(this));

			if (!$img.hasClass('loaded')) {
				$img.attr('src', $img.data('src')).addClass('loaded');
			}

		});
	}

	updatePostCounts();
	maybeLoadImages();


	$termList.on('click', 'a', function (e) {
		e.preventDefault();

		var $this = $(this),
			term = $this.data('slug');

		currentTerm = term;

		if ($this.hasClass('active')) {
			return;
		}
		$('a', $termList).removeClass('active');
		$this.addClass('active');

		if (0 === term) {
			resetChildren();
		} else {
			filterChildren(term);
		}

		$.event.trigger('pageChildrenSort');

	});


	$pagination.on('click', 'a', function (e) {
		e.preventDefault();

		var $showMore = $('#show-more', $(this));

		if ($showMore.is(':visible')) {
			loadMoreChildren();
		}

	});


	$(document).on('pageChildrenSort', function (evt) {
		maybeLoadImages();
		updatePostCounts();

	});


	var $flexslider = $('.page-flexslider');
	var prodSliderArgs = NidApp.getProductSliderArgs($flexslider);
	$flexslider.flexslider(prodSliderArgs);

}(jQuery));


/**
 * Additional verifications for front end users
 */
;(function ($) {
	var $loginform = $('#loginform');
	var $accept_terms = $('.accept-terms', $loginform);

	if ($loginform.length > 0 && $accept_terms.length > 0) {

		$loginform.submit(function (e) {
			var $username = $('#user_login');

			e.preventDefault();
			jQuery.ajax({
				type: 'POST',
				url: nordsjo.ajaxurl,
				data: {
					'action': 'nid_user_has_agreed_to_privacyterms',
					'user': $username.val(),
					'nid_fast_ajax': 1
				}
			}).done(function (result) {

				if (typeof result.data == 'undefined') {
					return false;
				}

				if (result.data.agreed == 'error') {
					$('.login .login-error').show();
				}

				if (result.data.agreed === false) {
					var $checkbox = $('#accept_terms', $accept_terms);

					if ($checkbox.attr('checked') == 'checked') {

						jQuery.ajax({
							type: 'POST',
							url: nordsjo.ajaxurl,
							data: {
								'action': 'nid_set_user_has_agreed_to_privacy_terms',
								'user': $username.val(),
								'nid_fast_ajax': 1
							}
						}).done(function (set_result) {

							if (result.success === true) {
								$(e.target).unbind('submit');
								$loginform.submit();
							} else {
								console.log('Fudge');
								// @todo Maybe do something useful
							}
						});

					} else {
						$checkbox.attr('checked', false);
						$accept_terms.show();
					}
				} else if (result.data.agreed === true) {
					$(e.target).unbind('submit');
					$loginform.submit();
				}
			});
		});
	}
}(jQuery));